import React, {useEffect} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import {t} from "i18next";
import {useSelector} from "react-redux";
import styled from "styled-components";
import {FlexRowSection} from "../styles/globalStyles";
import {getAttendanceDisplay} from "../helpers/functions";

const SessionBookingInfo = (props) => {
    const { displayProps, restStyle, course = false } = props;
    const loggedIn = useSelector(state => state.auth.loggedIn)

    if (course) {
        if (!((displayProps.showNumRegistered || displayProps.showNumOpenSpots) && !course?.isHugFull)) {
            return null;
        }
    
        return (
            <RowSection gap={'8px'} flex={'unset'} restStyle={restStyle}>
                <FontAwesomeIcon icon={solid('user')} color={Colors.siteBlack} size={'xs'}/>
                <span>{getAttendanceDisplay(displayProps, course)}</span>
            </RowSection>
        );
    }
    return (
        <>
            {loggedIn ?
            <RowSection gap={'8px'} flex={'unset'} restStyle={restStyle}>
                {(displayProps.showNumRegistered || displayProps.showNumOpenSpots) && <FontAwesomeIcon icon={solid('user')} color={Colors.siteBlack} size={'xs'}/>}
                {displayProps.showNumRegistered && displayProps.showNumOpenSpots && <span>{displayProps.registered}/{displayProps.maxUsers}</span>}
                {displayProps.showNumRegistered && !displayProps.showNumOpenSpots && <span>{t('num-booked', {num: displayProps.registered})}</span>}
                {!displayProps.showNumRegistered && displayProps.showNumOpenSpots && <span>{displayProps.openSpots === 0 ? t('full') : t('open-spots', {num: displayProps.openSpots})}</span>}
            </RowSection>
            :
                <RowSection gap={'8px'} flex={'unset'} restStyle={restStyle}>
                    <FontAwesomeIcon icon={solid('user')} color={Colors.siteBlack} size={'xs'}/>
                    <span>{displayProps.openSpots <= 0 ? t('full') : t('have-space')}</span>
                </RowSection>
            }
        </>
    );
};

export default SessionBookingInfo;

const RowSection = styled(FlexRowSection)`
    ${({restStyle}) => restStyle ?? ''}
`;